module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/soccer-e303c946771312f61c8d4eca514eeeef.svg";